// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../../provider/Context.bs.js";
import * as Atom_Row from "../../atom/Atom_Row.bs.js";
import * as Atom_Image from "../../atom/Atom_Image.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_String from "../../../type/Type_String.bs.js";
import * as Type_Teaser from "../../../type/Type_Teaser.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../particle/Particle_Spacer_Ds.bs.js";
import * as Organism_Newsletter from "../footer/Organism_Newsletter.bs.js";
import * as Organism_FooterLabels from "../footer/Organism_FooterLabels.bs.js";
import * as Particle_Background_Ds from "../../particle/Particle_Background_Ds.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";

var urlWithExtensionRegex = new RegExp("\.(gif|jpe?g|tiff?|png|webp|bmp)$", "i");

var extensionPng = ".png";

function addPngExtensionToResolutionUrl(src) {
  return Belt_Array.map(src, (function (resolution) {
                var urlString = Curry._1(Type_String.Href.toString, resolution.url);
                var match = urlString.match(urlWithExtensionRegex);
                if (match !== null) {
                  return resolution;
                } else {
                  return {
                          url: Curry._1(Type_String.Href.make, urlString.concat(extensionPng)),
                          w: resolution.w,
                          h: resolution.h
                        };
                }
              }));
}

var blockSpace = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.Outside.makeVerticalAndHorizontal("S", "XL", undefined)), undefined, undefined, Particle_Spacer_Ds.Outside.makeVerticalAndHorizontal("S", "None", undefined));

var justifyContent = Particle_Screen_Ds.make(undefined, undefined, "spaceBetween", undefined, undefined, "flexStart");

var Container = {
  blockSpace: blockSpace,
  justifyContent: justifyContent
};

var width = Particle_Screen_Ds.make(undefined, undefined, undefined, Css.pct(56), undefined, CssJs.pct(100));

var FormContainer = {
  width: width
};

var display = Particle_Screen_Ds.make(undefined, undefined, undefined, "inlineFlex", undefined, "none");

var width$1 = Particle_Screen_Ds.make(undefined, undefined, undefined, Css.pct(44), undefined, CssJs.pct(100));

var ImageContainer = {
  display: display,
  width: width$1
};

var Organism_NewsletterZone_Css = {
  Container: Container,
  FormContainer: FormContainer,
  ImageContainer: ImageContainer
};

function Organism_NewsletterZone(Props) {
  var blockSpace$1 = Props.blockSpace;
  var feedback = Props.feedback;
  var teaser = Props.teaser;
  var ref_ = Props.ref_;
  var match = Context.Config.getState(undefined);
  var newsletterZoneWithTeaserImageFf = Context.Config.getFeatureFlippingStatus(/* NewsletterZoneWithTeaserImage */1);
  var match$1 = Context.I18n.getState(undefined);
  var locale = match$1.locale;
  var match$2 = Organism_FooterLabels.getLabels(locale);
  var newsletter = match$2.newsletter;
  var teaserTitle = Curry._1(Type_String.Teaser.Title.toString, Belt_Option.getWithDefault(Type_Teaser.Helper.extractTitle(teaser), Type_String.Teaser.Title.empty));
  var labels_termOfUse = {
    text: newsletter.termOfUse.text,
    link: newsletter.termOfUse.link,
    textLink: newsletter.termOfUse.textLink
  };
  var labels_wrongEmailFormat = newsletter.wrongEmailFormat;
  var labels_button = Curry._1(Type_String.CallToAction.toString, Belt_Option.getWithDefault(teaser.callToAction, Type_String.CallToAction.empty));
  var labels_email = newsletter.email;
  var labels_inputTitle = newsletter.inputTitle;
  var labels_buttonAriaLabel = newsletter.buttonAriaLabel;
  var labels = {
    title: teaserTitle,
    termOfUse: labels_termOfUse,
    wrongEmailFormat: labels_wrongEmailFormat,
    button: labels_button,
    email: labels_email,
    inputTitle: labels_inputTitle,
    buttonAriaLabel: labels_buttonAriaLabel
  };
  var background = Particle_Background_Ds.Newsletter.newsletterZone(match.cdnUrl);
  var src = addPngExtensionToResolutionUrl(teaser.imageSrc);
  var tmp = {
    area: "newsletter",
    background: background,
    blockSpace: blockSpace,
    children: null,
    justifyContent: justifyContent
  };
  if (ref_ !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(ref_);
  }
  var tmp$1 = {
    labels: labels,
    style: /* Zone */1,
    source: "replay_banner"
  };
  if (feedback !== undefined) {
    tmp$1.feedback = Caml_option.valFromOption(feedback);
  }
  var tmp$2 = {
    children: React.createElement(Organism_Newsletter.make, tmp$1),
    justifyContent: Particle_Screen_Constants.justifyContentCenter,
    width: width
  };
  if (blockSpace$1 !== undefined) {
    tmp$2.blockSpace = Caml_option.valFromOption(blockSpace$1);
  }
  return React.createElement(Atom_Row.make, tmp, React.createElement(Atom_Column.make, tmp$2), React.createElement(Atom_Column.make, {
                  children: newsletterZoneWithTeaserImageFf ? React.createElement(Atom_Image.ImageFromCdn.make, {
                          alt: "",
                          style: {
                            TAG: /* FromCdn */1,
                            _0: {
                              TAG: /* Newsletter */2,
                              _0: locale
                            }
                          }
                        }) : React.createElement(Atom_Image.make, {
                          alt: "",
                          src: src,
                          style: /* Newsletter */7
                        }),
                  display: display,
                  width: width$1
                }));
}

var make = Organism_NewsletterZone;

export {
  urlWithExtensionRegex ,
  extensionPng ,
  addPngExtensionToResolutionUrl ,
  Organism_NewsletterZone_Css ,
  make ,
}
/* urlWithExtensionRegex Not a pure module */
